export default "__VITE_ASSET__BJ2qz0p3__"